import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useMe } from '@/hooks/useMe';

export function Shell() {
  useMe();
  return (
    <div className="flex h-full w-full">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto bg-canvas">
          <div className="mx-auto w-full max-w-[1440px] px-6 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
